( function($) {
	$( document ).ready( function() {

		/* nofollow for share buttons */
		$('a[id^=ssba_]').attr('rel','nofollow');

		/* recent articles "show more" button */
		$('#morePostsSet2').on('hidden.bs.collapse', function() {
			$('#showMoreBtn').text('Show more');
		});

		$('#morePostsSet2').on('shown.bs.collapse', function() {
			$('#showMoreBtn').css('display', 'none');
		});

		/* smooth scroll */
		$('.scroll-up').click(function() {
			$("html, body").animate({ scrollTop: 0 }, 600);
			return false;
		});

		$('.search-scroll').click(function() {
			if ($('.sidebar-item').length) {
				var buffer = parseInt($('.sidebar-item').css('marginBottom'));
			} else {
				var buffer = 12;
			}
			if ($('#searchBox').length) {
				var searchOffset = $('#searchBox').offset().top - buffer;
				$("html, body").animate({ scrollTop: searchOffset }, 600);
			}
			return false;
		});

		//LINK TRACKING PARAMERTERS

		// /hire link "Use Indeed to find your next hire" in Right Rail
		$('#employersBox a').attr('href', function() {
			return this.href + '?isid=employerbloglink-US&ikw=rightrail';
		});

		// Post a job top nav link
		$('#menu-item-6530 a').attr('href', function() {
			return this.href + '?isid=employerbloglink-US&ikw=topnav';
		});

		// Indeed for Employers in top nav
		$('#menu-item-6532 a').attr('href', function() {
			return this.href + '?isid=employerbloglink-US&ikw=topnav';
		});

		// Post a Job in footer:
		$('#menu-item-6603 a').attr('href', function() {
			return this.href + '?isid=employerbloglink-US&ikw=footer';
		});

	});

})(jQuery);
